import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import {
  QuestionLayout,
  SquareOptionButton,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useFamilyHistory } from "../FamilyHistoryContext";
import type { FamilyHistoryStackParamList } from "../FamilyHistoryNavigator";
import { YES_NO_UNKNOWN_OPTIONS, type YesNoUnknown } from "../options";

export function FamilyInfertilityScreen() {
  const t = useTranslations();
  const { state, updateState } = useFamilyHistory();
  const navigation =
    useNavigation<NavigationProp<FamilyHistoryStackParamList>>();

  const handleSelect = (value: YesNoUnknown) => {
    updateState({ hasRelativeFacingFertilityIssues: value });
    if (value !== "yes") {
      updateState({ familyMemberWithFertilityIssues: [] });
    }
  };

  const handleNext = () => {
    if (state.hasRelativeFacingFertilityIssues === "yes") {
      navigation.navigate("FamilyMember");
    } else {
      navigation.navigate("Des");
    }
  };

  return (
    <QuestionLayout
      title={t("med_history.family_history.family_infertility_title")}
      subtitle={t("med_history.family_history.family_infertility_subtitle")}
      onBack={() => navigation.goBack()}
      onSave={handleNext}
      saveDisabled={state.hasRelativeFacingFertilityIssues === null}
      saveLabel={t("med_history.shared.next")}
    >
      <View style={styles.container}>
        <View style={styles.topRow}>
          {YES_NO_UNKNOWN_OPTIONS.slice(0, 2).map((option) => (
            <SquareOptionButton
              key={option.id}
              icon={option.icon}
              label={t(option.labelKey)}
              isSelected={state.hasRelativeFacingFertilityIssues === option.id}
              onPress={() => handleSelect(option.id)}
              iconSize={24}
              containerSize={48}
              labelSize="lg"
            />
          ))}
        </View>
        <View style={styles.bottomRow}>
          <View style={styles.halfWidth}>
            <SquareOptionButton
              icon={YES_NO_UNKNOWN_OPTIONS[2]!.icon}
              label={t(YES_NO_UNKNOWN_OPTIONS[2]!.labelKey)}
              isSelected={state.hasRelativeFacingFertilityIssues === "unknown"}
              onPress={() => handleSelect("unknown")}
              iconSize={24}
              containerSize={48}
              labelSize="lg"
            />
          </View>
        </View>
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    marginBottom: 40,
  },
  topRow: {
    flexDirection: "row",
    gap: 12,
    width: "100%",
    marginBottom: 12,
  },
  bottomRow: {
    flexDirection: "row",
    width: "100%",
  },
  halfWidth: {
    width: "47%",
  },
});
